"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Progress = _interopRequireDefault(require("./Progress"));

var _hexToRgb = require("./hexToRgb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_COLOR = '#77b6ff';
var styles = {
  wrapper: {
    top: '0',
    left: '0',
    width: '100%',
    transition: 'all 500mx ease-in-out'
  },
  hiddenWrapper: {
    visibility: 'hidden',
    opacity: '0',
    zIndex: '-10'
  },
  visibleWrapper: {
    visibility: 'visible',
    opacity: '1',
    zIndex: '9999'
  },
  percent: {
    transition: 'all 400ms ease',
    height: '2px'
  }
};

function getWrapperStyles(isHidden) {
  var isAbsolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var visibilityStyles = isHidden ? styles.hiddenWrapper : styles.visibleWrapper;
  return _objectSpread({}, styles.wrapper, visibilityStyles, {
    position: isAbsolute ? 'absolute' : 'fixed'
  });
}

function getPercentStyles(color, percent) {
  var clientStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var customStyles = {
    width: percent <= 0 ? '0' : "".concat(percent, "%"),
    opacity: percent >= 99.9 ? '0' : '1'
  };
  return _objectSpread({}, styles.percent, {
    background: color,
    boxShadow: "0 0 10px ".concat((0, _hexToRgb.hexToRgb)(color, 0.7))
  }, clientStyles, customStyles);
}

var ProgressBarProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ProgressBarProvider, _React$PureComponent);

  function ProgressBarProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProgressBarProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProgressBarProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      color: (0, _hexToRgb.nameToHex)(_this.props.color, DEFAULT_COLOR)
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderProgress", function (percent) {
      // Hide progress bar if percent is less than 0.
      var isHidden = percent < 0 || percent >= 100; // Set `state.percent` as width.

      return _react.default.createElement("div", {
        style: getWrapperStyles(isHidden, _this.props.absolute)
      }, _react.default.createElement("div", {
        className: _this.props.className,
        style: getPercentStyles(_this.state.color, percent, _this.props.styles)
      }));
    });

    return _this;
  }

  _createClass(ProgressBarProvider, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_Progress.default, {
        isActive: this.props.isActive
      }, this.renderProgress);
    }
  }]);

  return ProgressBarProvider;
}(_react.default.PureComponent);

_defineProperty(ProgressBarProvider, "displayName", 'ProgressBarProvider');

_defineProperty(ProgressBarProvider, "defaultProps", {
  absolute: false,
  color: DEFAULT_COLOR
});

var _default = ProgressBarProvider;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-progress/es/ProgressBarProvider.js
// module id = 1062
// module chunks = 0